import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {NgForm} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {ARReportCustomerDto, PerFormaAPIService} from "src/app/services/pfapi.service";
import {lastValueFrom} from "rxjs";

@Component({
    selector: "app-customer-edit",
    templateUrl: "./customer-edit.component.html",
    styleUrl: "./customer-edit.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerEditComponent implements OnInit {
    isEditMode = false;
    loading = true;
    successMsg = "";
    errorMsg = "";

    customer: ARReportCustomerDto = {
        CustomerID: null,
        CustomerName: "",
        CustomerNumber: "",
        EmailAddress: "",
        ShouldEmail: false,
        ShouldPrint: false
    };

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private readonly api: PerFormaAPIService
    ) {}

    async ngOnInit() {
        this.route.queryParams.subscribe(p => {
            if (p.created === "true") {
                this.successMsg = "Created customer";
            }
        });

        await this.checkEditMode();
    }

    checkEditMode = async () => {
        const id = this.route.snapshot.queryParamMap.get("id");
        if (!id) {
            this.loading = false;
            return;
        }
        this.isEditMode = true;
        try {
            this.customer = await lastValueFrom(this.api.getApiReportArCustomersId(Number(id)));
        } catch (e) {
            const errors = e.error?.ModelState?.status;

            if (errors && Array.isArray(errors)) {
                this.errorMsg = errors[0];
            }
        } finally {
            this.loading = false;
        }
    };

    save = async (frm: NgForm) => {
        this.successMsg = "";
        this.errorMsg = "";

        frm.control.markAllAsTouched();

        if (!frm.valid) return;

        this.loading = true;
        try {
            if (this.isEditMode) {
                await lastValueFrom(this.api.putApiReportArCustomers(this.customer));
                frm.control.markAsUntouched();
                this.successMsg = "Modified customer";
            } else {
                const resp = await lastValueFrom(this.api.postApiReportArCustomers(this.customer));
                this.customer = resp;
                this.isEditMode = true;
                this.router.navigateByUrl(`/report/arreport/customeredit?id=${resp.CustomerID}&created=true`);
            }
            frm.control.markAsUntouched();
        } catch (e) {
            const errors = e.error?.ModelState?.status;

            if (errors && Array.isArray(errors)) {
                this.errorMsg = errors[0];
            }
        } finally {
            this.loading = false;
        }
    };

    remove = async () => {
        if (!confirm("Are you sure you want to delete this customer?")) {
            return;
        }
        try {
            this.loading = true;
            await lastValueFrom(this.api.deleteApiReportArCustomersId(this.customer.CustomerID));
            this.router.navigateByUrl("/report/arreport/customers");
        } catch (e) {
            const errors = e.error?.ModelState?.status;

            if (errors && Array.isArray(errors)) {
                this.errorMsg = errors[0];
            }
        } finally {
            this.loading = false;
        }
    };
}
